import { useEffect } from 'react'

export const useSEO = (SEOOptions: {
  title: string | null,
}) => {
  useEffect(() => {
    if (SEOOptions.title) {
      document.title = SEOOptions.title
    }
  }, [SEOOptions])
}
